"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NirgalEnterprises = void 0;
const Resources_1 = require("../../Resources");
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
const Units_1 = require("../../Units");
class NirgalEnterprises extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.NIRGAL_ENTERPRISES,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.PLANT, Tags_1.Tags.BUILDING],
            startingMegaCredits: 30,
            productionBox: Units_1.Units.of({ energy: 1, plants: 1, steel: 1 }),
            metadata: {
                cardNumber: '??',
                description: 'You start with 30 M€. Increase your energy, plant and steel production 1 step each.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br;
                    b.megacredits(30).production((pb) => pb.energy(1).plants(1).steel(1)).nbsp();
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.text('AWARDS AND MILESTONES ALWAYS COST 0 M€ FOR YOU.', Size_1.Size.SMALL);
                    });
                }),
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.addProduction(Resources_1.Resources.STEEL, 1);
        return undefined;
    }
}
exports.NirgalEnterprises = NirgalEnterprises;
//# sourceMappingURL=NirgalEnterprises.js.map